export default "__VITE_PUBLIC_ASSET__34503236__"